<template>
  <section class="header-con" id="headerv1">
    <div class="header">
      <div class="logo">
        <img :src="img1" alt="掌门1对1">
      </div>
      <div class="tel">
        <div>
          <img src="../../assets/image/common/tel2111_01.png" alt="掌门1对1">
          <span class="kefu-tel">400-620-8068</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'headerV1',
    props: {
      img1: {
        type: String,
        default: '../../../static/img/logo_new.png'
      }
    },
  }
</script>
<style lang="scss" rel="stylesheet/less" scoped>

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2rem(10) px2rem(44) 0 px2rem(44);
    height: px2rem(90);
    background: #fff;
    .logo {
      width: px2rem(300);
      img {
        width: 100%;
        /*height: px2rem(44);*/
      }
    }
    .tel {
      text-align: right;
      display: inline-block;
      img {
        width: px2rem(33);
        height: px2rem(31);
      }
      span {
        font-size: px2rem(40);
        color: rgb(199, 15, 29);
      }
    }
  }
</style>
